module.exports = __webpack_public_path__ + "img/go-button.c10a6002.png";